import { CommonService } from '../../shared/services/common-service/common-service';
import { QUALIFICATIONS_CATEGORIES } from '../../shared/constants/qualification-categories';
import { QuotaPayload } from '../../shared/interfaces/quota.interface';
import { OriginalQuotas } from './original-quotas';
import { QuotaIdentifierBuilder } from './quota-builder';
import { CategoryQuotaMatch, QuotaFilter } from './quota-filter';
import { QuotaNumberCount } from './quota-number-count';
import { RecreatedQuotas } from './recreated-quotas';

export class NestingQuotas {
  constructor(private readonly _quotas: QuotaPayload[]) {}

  rebuild(counter: QuotaNumberCount): QuotaPayload[] {
    const recreated = new RecreatedQuotas();

    for (let nested of this._quotas) {
      if (!nested.individual_quotas?.length) {
        recreated.add(new OriginalQuotas(nested).generate(counter));
      } else {
        for (let nestIndividual of nested.individual_quotas) {
          recreated.add(new OriginalQuotas(nestIndividual).generate(counter));
        }
      }
    }

    return recreated.all();
  }
}

export class Nesting {
  constructor(
    private readonly _quotas: QuotaPayload[],
    private readonly _commonService: CommonService
  ) {}

  public recreate(completes?: number, clicks?: number): QuotaPayload[] {
    const filter = new QuotaFilter(this._quotas);
    const isNested = new CategoryQuotaMatch(QUALIFICATIONS_CATEGORIES.NESTED);

    const nested = filter.quotas(isNested);
    const unNested = filter.unmatched().quotas(isNested);

    const recreated = new NestingQuotas(nested)
      .rebuild(new QuotaNumberCount(clicks, completes))
      .map((quota) =>
        new QuotaIdentifierBuilder(
          quota,
          this._commonService.getRandomString()
        ).build()
      );

    return [...unNested, ...recreated];
  }
}
